module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-949-retro.1bbe013e.jpg";